module.exports = __webpack_public_path__ + "img/AMS.67a69d64.svg";